export function formatBackendUTCDateString(dateString) {
  var dateFormatSeparators = /[-\/]+/;
  if (dateFormatSeparators.test(dateString)) {
    return dateString;
  }
  return (
    dateString.substring(0, 4) + "-" + dateString.substring(4, 6) + "-" + dateString.substring(6, 8)
  );
}
